export interface SyncResult { lastSuccess?: string; lastAttempt: string; successful: boolean; message: string }
export async function saveSyncResult(successful: boolean, message: string): Promise<void> {
    const settings = Office.context.document.settings;
    const previous = settings.get('bankSyncResult') as SyncResult | undefined;
    const now = new Date().toISOString();
    settings.set('bankSyncResult', { lastSuccess: successful ? now : previous?.lastSuccess, lastAttempt: now, successful, message });
    await new Promise<void>((resolve, reject) => settings.saveAsync(result => {
        if (result.status === Office.AsyncResultStatus.Succeeded) resolve();
        else reject(new Error(result.error?.message || 'Could not save sync status.'));
    }));
}
export async function readSyncResult(): Promise<SyncResult | undefined> {
    const settings = Office.context.document.settings;
    await new Promise<void>((resolve, reject) => settings.refreshAsync(result => {
        if (result.status === Office.AsyncResultStatus.Succeeded) resolve();
        else reject(new Error(result.error?.message || 'Could not read sync status.'));
    }));
    return settings.get('bankSyncResult') as SyncResult | undefined;
}
